// extracted by mini-css-extract-plugin
export default {"body":"Location_body__XF69e","body__1":"Location_body__1__j7tiw","dotted":"Location_dotted__fW32I"};